import React from "react";
import EducationForm from "./educationForm";
import EmploymentForm from "./employmentForm";
import CharacterForm from "./characterForm";
import ReferencesSingleSelect from "./referencesSingleSelect";

class ReferencesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      niNumber: props.niNumber,
      formType:
        props.initialState && props.initialState.referenceType
          ? props.initialState.referenceType
          : undefined
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.saveReference = this.saveReference.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value
    });
  }

  saveReference(data) {
    const { responsibleTeam } = this.props;

    const branches = {
      HEDC: "Edu-northwest@hrgo.co.uk",
      HEDE: "Edu-eastanglia@hrgo.co.uk",
      HEDU: "Edu-southeast@hrgo.co.uk",
      HEDH: "Edu-southeast@hrgo.co.uk"
    };

    const branchEmail = branches[responsibleTeam] || "Edu-southeast@hrgo.co.uk";

    const enrichedData = {
      candidateName: this.state.name,
      branchEmail,
      educationReference: true,
      ...data
    };

    this.props.saveReference(enrichedData);
  }

  TextInput(props) {
    return (
      <div className="form-group">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          type="text"
          className="form-control"
          id={props.id}
          name={props.id}
          value={props.value}
          onChange={this.handleInputChange}
          required={true}
          readOnly={true}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.TextInput({
          id: "name",
          label: "Candidate's Name",
          value: this.state.name
        })}
        {this.state.formType === "employment" &&
          this.TextInput({
            id: "niNumber",
            label: "Candidate's NI Number",
            value: this.state.niNumber
          })}
        <ReferencesSingleSelect
          description="Is this an Employment, Education or Character reference?"
          value={this.state.formType}
          name="formType"
          onSelect={this.handleInputChange}
          options={["employment", "education", "character"]}
        />

        {this.state.formType === "employment" && (
          <EmploymentForm
            saveReference={this.saveReference}
            initialState={this.props.initialState}
          />
        )}
        {this.state.formType === "education" && (
          <EducationForm
            saveReference={this.saveReference}
            initialState={this.props.initialState}
          />
        )}
        {this.state.formType === "character" && (
          <CharacterForm
            saveReference={this.saveReference}
            initialState={this.props.initialState}
          />
        )}
      </div>
    );
  }
}

export default ReferencesForm;
